import { render } from "./RequestDetail.vue?vue&type=template&id=d9ccc1c4&scoped=true"
import script from "./RequestDetail.js?vue&type=script&lang=js&external"
export * from "./RequestDetail.js?vue&type=script&lang=js&external"

import "./RequestDetail.scss?vue&type=style&index=0&id=d9ccc1c4&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9ccc1c4"]])

export default __exports__